export default {
  projectEdit: {
    component: () =>
      import("@/mods/archive/projectManage/detailView/ProjectManageInfo"),
  },
};
